import TagView from './tag-view'

export default TagView
